module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Attendance-Leaves/leave-authorization/leave-auth-grid/leave-auth-grid.component.css
// module id = ./src/app/hrms/Attendance-Leaves/leave-authorization/leave-auth-grid/leave-auth-grid.component.css
// module chunks = main